import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { debounceTime, filter, map, tap } from 'rxjs/operators';

@Component({
  selector: 'x-quantity-control',
  templateUrl: './quantity-control.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'x-quantity-control' },
})
export class QuantityControlComponent implements OnInit, OnDestroy {
  private _subscription = new Subscription();

  @Input() set itemQuantity(input: number) {
    if (this.quantityControl.touched) return;

    this.quantityControl.patchValue(input, { emitEvent: false });
    this.quantityControl.markAsTouched();
  }

  @Input() disabled = false;

  @Output()
  quantityUpdated = new EventEmitter<number>();

  quantityControl = new FormControl(1, { nonNullable: true });

  ngOnInit(): void {
    this._subscription.add(
      this.quantityControl.valueChanges
        .pipe(
          debounceTime(600),
          map((quantity) => Number(quantity)),
          filter((quantity) => Boolean(quantity)),
          tap((quantity) => this.quantityUpdated.emit(quantity)),
        )
        .subscribe(),
    );
  }

  plus() {
    this.quantityControl.patchValue(this.quantityControl.value + 1);
  }

  minus() {
    if (this.quantityControl.value === 1) return;
    this.quantityControl.patchValue(this.quantityControl.value - 1);
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  onFocusOut() {
    if (!this.quantityControl.value || this.quantityControl.value === 0) {
      this.quantityControl.patchValue(1);
    }
  }
}
